import React, { useRef, useState } from 'react';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CardProps,
    Divider,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { pink } from '@material-ui/core/colors';
import { ChatbotIcon } from 'src/components/ChatbotIcon';
import useLead from 'src/hooks/useLead';

/**
 * Represent the component to make a AI call to a lead
 *
 * @param {*} { ...props }
 * @return {*}
 */
export const MakeAICall = ({ ...props }: CardProps) => {
    const { t } = useTranslation();
    const { lead, makeAICall } = useLead();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);

    const title: string = t('Calls.AICall');
    const buttonText: string = t('Calls.MakeAICall');

    const callCustomer = async () => {
        if (isSubmittingRef.current) return;

        isSubmittingRef.current = true;
        setIsSubmitting(true);

        try {
            await makeAICall(lead._id);
        } finally {
            isSubmittingRef.current = false;
            setIsSubmitting(false);
        }
    };

    return (
        <Card {...props} data-testid="make-ai-call-component">
            <CardHeader data-testid="ai-call-header" title={title} />
            <Divider />
            <CardContent>
                <Button
                    data-testid="make-ai-call-button"
                    variant="contained"
                    type="button"
                    size="large"
                    fullWidth
                    color="primary"
                    startIcon={<ChatbotIcon />}
                    onClick={callCustomer}
                    disabled={isSubmitting}
                    style={{
                        backgroundColor: pink['A100'],
                        height: 60,
                    }}
                >
                    {isSubmitting ? t('Calls.StartingAICall') : buttonText}
                </Button>
            </CardContent>
        </Card>
    );
};
